import * as React from "react";
import { forwardRef } from "react";
const SvgAxial = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g clipPath="url(#clip0_297_5)"><path d="M24 0H0V24H24V0Z" fill="#FF0100" /><path d="M8.02808 16.5L10.9801 8.77197H12.4441L15.3721 16.5H14.0281L13.2601 14.508H10.1521L9.38408 16.5H8.02808ZM10.3561 13.5H13.0441L11.7001 9.95997L10.3561 13.5Z" fill="#CCCCCC" /></g><defs><clipPath id="clip0_297_5"><rect width={24} height={24} fill="white" /></clipPath></defs></svg>;
const ForwardRef = forwardRef(SvgAxial);
export { ForwardRef as ReactComponent };